'use client';

import { useEffect } from 'react';
import { useCurrencyStore } from '@/features/shared/currency-store';
import { currencySelectors } from '@/features/shared/currency-selectors';
import { getGeoLocationOnClient } from '@/shared/utils/geo-location/get-geolocation-on-client';

/**
 * Seeds the region store from `/api/geolocation` once per page load.
 *
 * Client-side on purpose: the layout that renders this is shared with ~20 `force-static`
 * pages, and reading the geo headers on the server would opt every one of them out of
 * static rendering.
 */
export const RegionHydrator = () => {
  const setRegion = useCurrencyStore(currencySelectors.setRegion);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const geo = await getGeoLocationOnClient();
      if (!geo || cancelled) return;

      setRegion({ countryISO: geo.countryISO, currency: geo.currency });
    })();

    return () => {
      cancelled = true;
    };
  }, [setRegion]);

  return null;
};
